import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    quantity: {
      type: Number,
      default: 1
    }
  }

  connect() {
    this.updateStickyColumns()
    this.updateStickyColumns = this.updateStickyColumns.bind(this)
    window.addEventListener("resize", this.updateStickyColumns)
    document.addEventListener("turbo:frame-load", this.updateStickyColumns)
  }

  disconnect() {
    window.removeEventListener("resize", this.boundUpdateStickyColumns)
    document.removeEventListener("turbo:frame-load", this.boundUpdateStickyColumns)
  }

  updateStickyColumns() {
    const quantity = this.quantityValue
    const rows = this.element.querySelectorAll("thead tr, tbody tr")

    rows.forEach(row => this.applyStickyToRow(row, quantity))
  }

  applyStickyToRow(row, quantity) {
    let leftOffset = 0
    const cells = Array.from(row.children).slice(0, quantity)

    cells.forEach((cell, index) => {
      cell.classList.add("table-sticky-cell")
      cell.style.left = `${leftOffset}px`

      leftOffset += cell.offsetWidth

      const isLastCell = index + 1 === quantity

      if (isLastCell) {
        cell.classList.add("table-sticky-cell-last")
      }
    })
  }
}
